import React, { useContext, useEffect, useState, useMemo } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import Page from '../../../../layout/Page/Page';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from '../../../../components/bootstrap/Card';
import Button from '../../../../components/bootstrap/Button';
import { DefaultContext } from '../../../../contexts/default';
import Money from '../../../../helpers/utils/money/money';
import Spinner from '../../../../components/bootstrap/Spinner';
import SalesDB from '../../../../database/wrappers/sales';
import useDashData from '../../../../hooks/useDashData';
import OrdersIfoodDB from '../../../../database/wrappers/orderIfood';
import { STATUS_ORDER } from '../../../../types/statusOrderDelivery';
import useTotalByDay from '../../../../hooks/useTotalByDay';
import useCmvProducts from '../../../../hooks/reports/useCmvProducts';
import useCmvHistory from '../../../../hooks/reports/useCmvHistory';
import DreDB from '../../../../database/wrappers/dre';
import { exportXlsx } from '../../../../utils/exportFile';
import FilterDre from './filterDre';
import MoneyElement from '../../../../components/MoneyElement';
import Orders99DB from '../../../../database/wrappers/orders99';


const GeralDre = () => {
    const [dataFilter, setDataFilter] = useState({
        estab: '',
        store: '',
        firstDate: '',
        secondDate: '',
    });
    const [filterMenu, setFilterMenu] = useState(false);
    const { rows: cmvProductRows, loading: loadingCmv } = useCmvProducts(dataFilter);
    const { reports: cmvReports } = useCmvHistory(dataFilter);
    const [dreConfig, setDreConfig] = useState(null);
    const [loadingDre, setLoadingDre] = useState(false);
    const dreDb = useMemo(() => new DreDB(dataFilter.estab || 'x'), [dataFilter.estab]);

    const salesdb = useMemo(() => new SalesDB(dataFilter.estab || 'x'), [dataFilter.estab]);
    const ifooddb = useMemo(() => new OrdersIfoodDB(dataFilter.estab || 'x'), [dataFilter.estab]);
    const food99db = useMemo(() => new Orders99DB(dataFilter.estab || 'x'), [dataFilter.estab]);

    const { rows: sales, loading: loadingSales } = useDashData(filterMenu, dataFilter, salesdb);
    const { rows: salesIfood, loading: loadingSalesIfood } = useDashData(filterMenu, dataFilter, ifooddb);
    const { rows: sales99, loading: loadingSales99 } = useDashData(filterMenu, dataFilter, food99db);

    const { mergedByDay } = useTotalByDay([
        ...sales,
        ...sales99.filter((order) => order.status === STATUS_ORDER.CONCLUIDO),
        ...salesIfood.filter((order) => order.status === STATUS_ORDER.CONCLUIDO),
    ]);

    const totalBrutoIfood = useMemo(() => {
        return mergedByDay.reduce((acc, day) => acc + (day.totalIfood || 0), 0);
    }, [mergedByDay]);

    const totalBruto99 = useMemo(() => {
        return mergedByDay.reduce((acc, day) => acc + (day.total99 || 0), 0);
    }, [mergedByDay]);

    const totalDeliveryFeeIfood = useMemo(() => {
        const pedidosConcluidos = salesIfood.filter(
            (order) => order.status === STATUS_ORDER.CONCLUIDO
        );
        return pedidosConcluidos.reduce((acc, order) => {

            return acc + (order.deliveryFee || 0);
        }, 0);
    }, [salesIfood]);

    const totalFaturamentoIfood = totalBrutoIfood - totalDeliveryFeeIfood;
    const totalFaturamento = useMemo(() => {
        return mergedByDay.reduce((acc, day) => acc + (day.total || 0), 0);
    }, [mergedByDay]);

    const cmvTotals = useMemo(() => {
        const totalCost = cmvProductRows.reduce((sum, r) => sum + (r.totalCost || 0), 0);

        let totalCustoManual = 0;
        let totalCustoPerda = 0;
        let totalCustoPromocional = 0;

        cmvReports.forEach((r) => {
            if (r.days) {
                for (const dayKey in r.days) {
                    const day = r.days[dayKey];
                    const price = day?.priceUn ?? 0;
                    const qtd = day?.qtdExit ?? 0;
                    const priceUn = day?.priceUn ?? 0;
                    const qtdLoss = day?.qtdLoss ?? 0;
                    const qtdPromotial = day?.qtdPromotial ?? 0;

                    totalCustoManual += price * qtd;
                    totalCustoPerda += priceUn * qtdLoss;
                    totalCustoPromocional += priceUn * qtdPromotial;
                }
            }
        });

        const totalSaidaReal = totalCustoManual + totalCustoPerda + totalCustoPromocional;

        return {
            totalCmvAutomatico: totalCost,
            totalCmvReal: totalSaidaReal,
        };
    }, [cmvProductRows, cmvReports]);


    useEffect(() => {
        const fetchDreConfig = async () => {
            if (!dataFilter.estab) return;

            setLoadingDre(true);
            try {
                const { firstDate } = dataFilter;

                if (!firstDate) {
                    setDreConfig(null);
                    setLoadingDre(false);
                    return;
                }

                const d = new Date(firstDate);
                const mes = d.getMonth() + 1;
                const ano = d.getFullYear();

                const results = await dreDb.queryByMonthYear(mes, ano);

                if (results && results.length > 0) {
                    setDreConfig(results[0]);
                } else {
                    setDreConfig(null);
                }
            } catch (error) {
                console.error("Erro ao buscar config DRE:", error);
                setDreConfig(null);
            } finally {
                setLoadingDre(false);
            }
        };

        fetchDreConfig();
    }, [dreDb, dataFilter.estab, dataFilter.firstDate]);


    const dreCalculado = useMemo(() => {
        if (!dreConfig) {
            return null;
        }

        const totalPDV = mergedByDay.reduce((acc, day) => acc + (day.total || 0), 0);
        const totalIfood = mergedByDay.reduce((acc, day) => acc + (day.totalIfood || 0), 0);
        const total99 = mergedByDay.reduce((acc, day) => acc + (day.total99 || 0), 0);

        const totalRappi = mergedByDay.reduce((acc, day) => acc + (day.totalRappi || 0), 0);
        const receitaBruta = totalPDV + totalIfood + totalRappi + total99;

        const impostoSimples = Number(dreConfig.impostos?.simples) || 0;
        const impostoPis = Number(dreConfig.impostos?.pis) || 0;
        const impostoCofins = Number(dreConfig.impostos?.cofins) || 0;
        const impostoIss = Number(dreConfig.impostos?.iss) || 0;
        const totalImpostos = impostoSimples + impostoPis + impostoCofins + impostoIss;

        const receitaLiquida = receitaBruta - totalImpostos;

        const cmvAutomatico = cmvTotals.totalCmvAutomatico;
        const custoDeliveryIfood = totalDeliveryFeeIfood;
        const margemContribuicaoBruta = receitaLiquida - cmvAutomatico;

        const custoRoyalties = Number(dreConfig.custosVariaveis?.royalties) || 0;
        const custoPropaganda = Number(dreConfig.custosVariaveis?.fundo_propaganda) || 0;
        const custoMaquininha = Number(dreConfig.custosVariaveis?.taxas_maquininha) || 0;
        const custoIfood = Number(dreConfig.custosVariaveis?.taxa_ifood) || 0;
        const custoEmbalagens = Number(dreConfig.custosVariaveis?.embalagens) || 0;
        const custoVariavelTotal = custoRoyalties + custoPropaganda + custoMaquininha + custoIfood + custoEmbalagens;

        const margemContribuicaoLiquida = margemContribuicaoBruta - custoVariavelTotal;

        const custoFixoPessoal = (Number(dreConfig.custosFixos?.custoPessoal) || 0);
        const custoFixoOcupacional = (Number(dreConfig.custosFixos?.ocupacional) || 0);
        const custoFixoUtilidades = (Number(dreConfig.custosFixos?.utilidades) || 0);
        const custoFixoServicos = (Number(dreConfig.custosFixos?.servicosTerceiros) || 0);
        const custoFixoAdmin = (Number(dreConfig.custosFixos?.administrativa) || 0);
        const custoFixoTotal = custoFixoPessoal + custoFixoOcupacional + custoFixoUtilidades + custoFixoServicos + custoFixoAdmin;

        const lucroBruto = margemContribuicaoLiquida - custoFixoTotal;

        return {
            receitaBruta, totalPDV, totalIfood, totalRappi, total99,
            totalImpostos, impostoSimples, impostoPis, impostoCofins, impostoIss,
            receitaLiquida,
            cmvAutomatico,
            custoDeliveryIfood,
            margemContribuicaoBruta,
            custoVariavelTotal, custoRoyalties, custoPropaganda, custoMaquininha, custoIfood, custoEmbalagens,
            margemContribuicaoLiquida,
            custoFixoTotal, custoFixoPessoal, custoFixoOcupacional, custoFixoUtilidades, custoFixoServicos, custoFixoAdmin,
            lucroBruto
        };

    }, [mergedByDay, cmvTotals, dreConfig]);

    const dreColumns = useMemo(() => [
        { label: 'Descrição', field: 'description' },
        {
            label: 'Valor',
            field: 'value',
            isCurrency: true
        }
    ], []);
    const dreRows = useMemo(() => {
        if (!dreCalculado) return [];

        return [
            { id: 1, description: 'IMPOSTOS', value: dreCalculado.totalImpostos },
            { id: 2, description: '  Simples', value: dreCalculado.impostoSimples },
            { id: 3, description: '  PIS', value: dreCalculado.impostoPis },
            { id: 4, description: '  COFINS', value: dreCalculado.impostoCofins },
            { id: 5, description: '  ISS', value: dreCalculado.impostoIss },
            { id: 6, description: 'RECEITA LÍQUIDA', value: dreCalculado.receitaLiquida },
            { id: 7, description: 'CMV AUTOMÁTICO', value: dreCalculado.cmvAutomatico },
            { id: 8, description: 'MARGEM DE CONTRIBUIÇÃO BRUTA', value: dreCalculado.margemContribuicaoBruta },
            { id: 9, description: 'CUSTOS VARIÁVEIS', value: dreCalculado.custoVariavelTotal },
            { id: 10, description: '  Royalties', value: dreCalculado.custoRoyalties },
            { id: 11, description: '  Fundo Propaganda', value: dreCalculado.custoPropaganda },
            { id: 12, description: '  Taxas Adquirente', value: dreCalculado.custoMaquininha },
            { id: 13, description: '  Taxa iFood', value: dreCalculado.custoIfood },
            { id: 14, description: '  Embalagens', value: dreCalculado.custoEmbalagens },
            { id: 15, description: 'MARGEM DE CONTRIBUIÇÃO LÍQUIDA', value: dreCalculado.margemContribuicaoLiquida },
            { id: 16, description: 'CUSTOS FIXOS', value: dreCalculado.custoFixoTotal },
            { id: 17, description: '  Custo Pessoal', value: dreCalculado.custoFixoPessoal },
            { id: 18, description: '  Ocupacional', value: dreCalculado.custoFixoOcupacional },
            { id: 19, description: '  Utilidades', value: dreCalculado.custoFixoUtilidades },
            { id: 20, description: '  Serviços Terceiros', value: dreCalculado.custoFixoServicos },
            { id: 21, description: '  Administrativo', value: dreCalculado.custoFixoAdmin },
            { id: 22, description: 'LUCRO BRUTO', value: dreCalculado.lucroBruto },
        ];
    }, [dreCalculado]);

    const handleExport = () => {
        const fileName = `DRE`;
        exportXlsx(dreRows, dreColumns, fileName);
    };


    return (
        <>
            <PageWrapper>
                <SubHeader>
                    <SubHeaderLeft>
                        <Breadcrumb
                            list={[
                                { title: 'DRE', to: '/reports/Dre' },
                                {
                                    title: 'Dre',
                                    to: '/reports/Dre',
                                },
                            ]}
                        />
                    </SubHeaderLeft>
                    <SubHeaderRight>
                        <Button
                            icon='FileDownload'
                            color='info'
                            className='ms-2'
                            onClick={handleExport}
                        >
                            Exportar XLS
                        </Button>
                        <FilterDre onChange={setDataFilter} />
                    </SubHeaderRight>
                </SubHeader>
                <Page container='fluid'>
                    <>
                        <Card>
                            <CardHeader>
                                <CardTitle>Visão Geral</CardTitle>
                            </CardHeader>
                            <CardBody className='table-responsive p-5'>
                                <div className='row text-center gy-4'>
                                    <div className='col-lg-3 col-md-6'>
                                        <MoneyElement
                                            classLigth='bg-l25-success'
                                            title='Faturamento Geral'
                                            value={Money.centsToMaskMoney(totalFaturamento + totalFaturamentoIfood + totalBruto99)}
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <MoneyElement
                                            classLigth='bg-l25-info'
                                            title='Faturamento Pdv'
                                            value={Money.centsToMaskMoney(totalFaturamento)}
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <MoneyElement
                                            classLigth='bg-l25-primary'
                                            title='Faturamento Delivery'
                                            value={Money.centsToMaskMoney(totalFaturamentoIfood + totalBruto99)}
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <MoneyElement
                                            classLigth='bg-l25-danger'
                                            title='Cmv'
                                            value={Money.centsToMaskMoney(cmvTotals.totalCmvAutomatico)}
                                        />
                                    </div>

                                </div>
                            </CardBody>
                        </Card>
                        {loadingDre && (
                            <div className='p-5 text-center'>
                                <Spinner />
                            </div>
                        )}

                        {!loadingDre && dreCalculado && (
                            <Card>
                                <CardBody className='p-4'>
                                    <div className='row gy-4'>
                                        <div className='col-12  pt-2 bg-light'>
                                            <div className='d-flex justify-content-between'>
                                                <span className='fw-bold fs-5 text-dark'>RECEITA BRUTA</span>
                                                <span className='fw-bold fs-5 text-success'>{Money.centsToMaskMoney(dreCalculado.receitaBruta)}</span>
                                            </div>
                                        </div>
                                        <div className='col-12  pb-2'>
                                            <div className='col-12  pt-2 bg-light'>
                                                <div className='d-flex justify-content-between'>
                                                    <span className='fw-bold fs-5 text-dark'>IMPOSTOS</span>
                                                    <span className='fw-bold fs-5 text-success'>
                                                        {Money.centsToMaskMoney(dreCalculado.totalImpostos)}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='ms-4 mt-2'>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Simples</span>
                                                    <span className='text-dark'>{Money.centsToMaskMoney(dreCalculado.impostoSimples)}</span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>PIS</span>
                                                    <span className='text-dark'>{Money.centsToMaskMoney(dreCalculado.impostoPis)}</span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>COFINS</span>
                                                    <span className='text-dark'>{Money.centsToMaskMoney(dreCalculado.impostoCofins)}</span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>ISS</span>
                                                    <span className='text-dark'>{Money.centsToMaskMoney(dreCalculado.impostoIss)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12  pt-2 bg-light'>
                                            <div className='d-flex justify-content-between'>
                                                <span className='fw-bold fs-5 text-dark'>RECEITA LÍQUIDA</span>
                                                <span className='fw-bold fs-5 text-success'>{Money.centsToMaskMoney(dreCalculado.receitaLiquida)}</span>
                                            </div>
                                        </div>

                                        <div className='col-12  pt-2 bg-light'>
                                            <div className='d-flex justify-content-between'>
                                                <span className='fw-bold fs-5 text-dark'>MARGEM DE CONTRIBUIÇÃO BRUTA</span>
                                                <span className='fw-bold fs-5 text-success'>{Money.centsToMaskMoney(dreCalculado.margemContribuicaoBruta)}</span>
                                            </div>
                                        </div>

                                        <div className='col-12  pb-2 mt-3'>
                                            <div className='col-12  pt-2 bg-light'>
                                                <div className='d-flex justify-content-between'>
                                                    <span className='fw-bold fs-5 text-dark'>CUSTOS VARIÁVEIS</span>
                                                    <span className='fw-bold fs-5 text-success'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoVariavelTotal)}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='ms-4 mt-2'>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Royalties</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoRoyalties)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Fundo Propaganda</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoPropaganda)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Taxas Adquirente</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoMaquininha)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Taxa iFood</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoIfood)}
                                                    </span>
                                                </div>

                                                <div className='d-flex justify-content-between'>
                                                    <span>Taxa de entrega</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoDeliveryIfood)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Embalagens</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoEmbalagens)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-12  pt-2 bg-light'>
                                            <div className='d-flex justify-content-between'>
                                                <span className='fw-bold fs-5 text-dark'> MARGEM DE CONTRIBUIÇÃO LÍQUIDA</span>
                                                <span className='fw-bold fs-5 text-success'>{Money.centsToMaskMoney(dreCalculado.margemContribuicaoLiquida)}</span>
                                            </div>
                                        </div>

                                        <div className='col-12  pb-2 mt-3'>
                                            <div className='d-flex justify-content-between'>
                                                <span className='fw-bold fs-5 text-dark'>CUSTOS FIXOS</span>
                                                <span className='fw-bold fs-5 text-success'>
                                                    {Money.centsToMaskMoney(dreCalculado.custoFixoTotal)}
                                                </span>
                                            </div>
                                            <div className='ms-4 mt-2'>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Custo Pessoal</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoFixoPessoal)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Ocupacional</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoFixoOcupacional)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Utilidades</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoFixoUtilidades)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Serviços Terceiros</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoFixoServicos)}
                                                    </span>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <span>Administrativo</span>
                                                    <span className='text-dark'>
                                                        {Money.centsToMaskMoney(dreCalculado.custoFixoAdmin)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12  pt-3 bg-success-subtle p-3 rounded'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <span className='fw-bold fs-4 text-sucess'>LUCRO BRUTO</span>
                                                <span
                                                    className={`fw-bold fs-4 text-primary
                                                    `}
                                                >
                                                    {Money.centsToMaskMoney(dreCalculado.lucroBruto)}
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </CardBody>
                            </Card>
                        )}
                    </>

                </Page>
            </PageWrapper >
        </>
    );
};

export default GeralDre;